import React from "react";

function KeyValueLeftRight({ label = "", placeholder = "None", equal = false, children = "", className = "", contentClass = "" }) {
	return (
		<>
			<div className={`text-sm ${className}`}>
				<div className="grid grid-cols-1 gap-2 sm:grid-cols-12 sm:items-center">
					<div className={equal ? "sm:col-span-6" : "sm:col-span-4"}>
						<div className="text-secondary">{label}</div>
					</div>
					<div className={`${equal ? "sm:col-span-6 sm:pl-6" : "sm:col-span-8"} min-w-0 ${contentClass}`}>{children ? children : placeholder}</div>
				</div>
			</div>
		</>
	);
}

export default KeyValueLeftRight;
